<div class="form-group" [class.has-error]="isInvalid()">
    <label class="col-sm-4 control-label" [attr.for]="getId()">{{label}}</label>
    <div class="col-sm-8">
         <ng-content></ng-content>
         <eau-validation-errors [form]="form" [key]="key"></eau-validation-errors>
    </div>
</div>
